import { Circle } from '@amcharts/amcharts4/core';
import { CircleBullet } from '@amcharts/amcharts4/charts';

export function animateExpand(bullet: CircleBullet) {
	let animation = bullet.animate({ property: 'scale', to: 1.5 }, 500);
	animation.events.on('animationended', function() {
		animateCollapse(bullet);
	});
}

export function animateCollapse(bullet: CircleBullet) {
	let animation = bullet.animate({ property: 'scale', to: 1 }, 100);
	animation.events.on('animationended', function() {
		animateExpand(bullet);
	});
}

export function animateExpand2(bullet: Circle) {
	let animation = bullet.animate(
		[
			{ property: 'scale', to: 3 },
			{ property: 'opacity', from: 0.5, to: 0 },
		],
		500,
	);
	animation.events.on('animationended', function() {
		animateCollapse2(bullet);
	});
}

export function animateCollapse2(bullet: Circle) {
	let animation = bullet.animate({ property: 'scale', to: 1 }, 100);
	animation.events.on('animationended', function() {
		animateExpand2(bullet);
	});
}
